import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { OnboardingCockpit } from "../features/onboardingRuns/OnboardingCockpit";

type Tab = "runs" | "prepare";

interface OnboardingSearch {
  site?: string;
  run?: string;
  tab?: Tab;
}

export const Route = createFileRoute("/onboarding-runs")({
  validateSearch: (search: Record<string, unknown>): OnboardingSearch => ({
    site: typeof search.site === "string" ? search.site : undefined,
    run: typeof search.run === "string" ? search.run : undefined,
    tab: search.tab === "runs" || search.tab === "prepare" ? search.tab : undefined,
  }),
  component: OnboardingRunsRoute,
});

function OnboardingRunsRoute() {
  const { site, run, tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const patch = (p: Partial<OnboardingSearch>) =>
    void navigate({ search: (prev) => ({ ...prev, ...p }), replace: true });
  return (
    <OnboardingCockpit
      tab={tab ?? null}
      site={site ?? null}
      run={run ?? null}
      onTabChange={(t) => patch({ tab: t })}
      onSiteChange={(slug) => patch({ site: slug ?? undefined })}
      onRunChange={(id) => patch({ run: id ?? undefined, tab: "runs" })}
    />
  );
}
